import http from '@/http'
const URL = '/admin/reports'

export const listParticipants = async (params) => {
  const list = (await http.get(URL + '/participants?include=ref,transports,contact,companion,attachments,group', { params: params })).data
  return list
}

export const exportParticipantsAir = async (params) => {
  const data = (await http.get(URL + '/participants/exportAir', { params: params, responseType: 'blob' })).data
  return data
}

export const listGalistas = async (params) => {
  const list = (await http.get(URL + '/participantsGalistas?include=ref,transports,contact,companion,attachments,group', { params: params })).data
  return list
}

export const listParticipantsPayments = async (params) => {
  const list = (await http.get(URL + '/participantsPayments?include=orders.ticket,orders.cupom,orders.transactions,orders.transactionsPix,contacts,group', { params: params })).data
  return list
}

export const exportParticipants = async (params) => {
  const data = (await http.get(URL + '/participants/export', { params: params, responseType: 'blob' })).data
  return data
}

export const exportGalistasAll = async (params) => {
  const data = (await http.get(URL + '/participants/exportGalistasAll', { params: params, responseType: 'blob' })).data
  return data
}

export const exportParticipantsAll = async (params) => {
  const data = (await http.get(URL + '/participants/exportAll', { params: params, responseType: 'blob' })).data
  return data
}

export const exportParticipantsPayments = async (params) => {
  const data = (await http.get(URL + '/participants/exportPaymentAll', { params: params, responseType: 'blob' })).data
  return data
}

export const listGuests = async (params) => {
  const list = (await http.get(URL + '/guests', { params: params })).data
  return list
}

export const exportGuests = async (params) => {
  const data = (await http.get(URL + '/guests/export', { params: params, responseType: 'blob' })).data
  return data
}
export const exportParticipantsCompanions = async (params, format = 'stacked') => {
  const data = (await http.get(URL + '/participants/exportCompanionsAll', { params: { ...params, format }, responseType: 'blob' })).data
  return data
}

export const getAvailableTypes = async () => {
  const res = await http.get(URL + '/available-types')
  return res.data
}

// Relatório de Coleta de Lead — uma linha por submissão
export const listLeadCollection = async (params) => {
  const list = (await http.get(URL + '/lead-collection', { params: params })).data
  return list
}

export const exportLeadCollection = async (params) => {
  const data = (await http.get(URL + '/lead-collection/export', { params: params, responseType: 'blob' })).data
  return data
}

// Relatório de Retirada de Brinde — uma linha por retirada vigente
export const listGiftCollection = async (params) => {
  const list = (await http.get(URL + '/gift-collection', { params: params })).data
  return list
}

export const exportGiftCollection = async (params) => {
  const data = (await http.get(URL + '/gift-collection/export', { params: params, responseType: 'blob' })).data
  return data
}

export const listParticipantsFinancials = async (params) => {
  const list = (await http.get(URL + '/participantsFinancials', { params: params })).data
  return list
}

export const exportParticipantsFinancials = async (params) => {
  const data = (await http.get(URL + '/participantsFinancials/export', { params: params, responseType: 'blob' })).data
  return data
}

export default {
  exportParticipantsPayments,
  listParticipantsPayments,
  listParticipants,
  exportParticipants,
  exportParticipantsAir,
  exportParticipantsAll,
  exportParticipantsCompanions,
  exportGalistasAll,
  listGuests,
  listGalistas,
  exportGuests,
  getAvailableTypes,
  listLeadCollection,
  exportLeadCollection,
  listGiftCollection,
  exportGiftCollection,
  listParticipantsFinancials,
  exportParticipantsFinancials
}
